//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InfiniteLoading from 'vue-infinite-loading'

import { mapGetters } from 'vuex'

export default {
  components: {
    InfiniteLoading
  },
  data () {
    return {
      loading: false,
      limit: 24
    }
  },
  async fetch () {
    await this.$store.dispatch('story/LIST')
  },
  head () {
    return {
      title: this.getTitle('We are SunGod'),
      meta: [
        ...this.getDescription('SunGod Stories are a collection of adventures from across the world, writter by our Pro Team, Pioneers and Ambassadors.'),
        { hid: 'og:title', property: 'og:title', content: this.getTitle('We are SunGod') }
      ]
    }
  },
  computed: {
    ...mapGetters({
      count: 'story/count',
      numberLoaded: 'story/numberLoaded'
    }),
    stories () {
      let stories = this.$store.getters['story/stories'].slice(0, this.limit)
      if (this.category) stories = stories.filter(story => story.category === this.category)
      return stories
    },
    category () {
      const category = this.$route.params.category || null
      if (!['stories', 'news', 'video', 'pro-team'].includes(category)) return null
      return category
    }
  },
  methods: {
    async loadMore (infiniteState) {
      if (this.limit + 4 > this.numberLoaded) await this.$store.dispatch('story/GET_MORE')
      this.limit += 4
      if (this.limit > this.count) return infiniteState.complete()
      infiniteState.loaded()
    }
  }
}
